import styled from "styled-components";
import {
  DashboardRounded,
  FileCopyRounded,
  AnnouncementRounded,
} from "@mui/icons-material";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/authContext/AuthContext";

const Container = styled.div`
  flex: 1;
  height: calc(100vh - 50px);
  max-width: 250px;
  position: sticky;
  top: 50px;
  background-color: #ececec;
`;
const Wrapper = styled.div`
  margin-bottom: 10px;
  padding: 20px;
  color: #434446;
`;

const MenuList = styled.ul`
  list-style: none;
  padding: 10px;
`;
const MenuItem = styled.li`
  padding: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  border-radius: 5px;
  &:hover {
    background-color: #88bfd3;
    color: white;
  }
  &.active {
    background-color: #88bfd3;
    color: white;
  }
`;

const Sidebar = () => {
  const { user } = useContext(AuthContext);

  if (!user) {
    return <></>;
  }
  return (
    <Container>
      <Wrapper>
        <MenuList>
          <Link to="/dashboard" className="link">
            <MenuItem>
              <DashboardRounded className="sidebarIcon" />
              Dashboard
            </MenuItem>
          </Link>
          <Link to="/orders" className="link">
            <MenuItem>
              <FileCopyRounded className="sidebarIcon" />
              Orders
            </MenuItem>
          </Link>
          <Link to="/claims" className="link">
            <MenuItem>
              <AnnouncementRounded className="sidebarIcon" />
              Claims
            </MenuItem>
          </Link>
        </MenuList>
      </Wrapper>
    </Container>
  );
};

export default Sidebar;
